import { render } from "./QueueDetailTableOutboundDuration.vue?vue&type=template&id=4f6feaf4"
import script from "./QueueDetailTableOutboundDuration.vue?vue&type=script&lang=js"
export * from "./QueueDetailTableOutboundDuration.vue?vue&type=script&lang=js"

import "./QueueDetailTableOutboundDuration.vue?vue&type=style&index=0&id=4f6feaf4&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__